/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';

type SendEmailModalLayoutProps = {
  isOpen: boolean;
  countdownTime: number;
  closeModal: () => void;
  undoEmailSending: () => void;
};

const SendEmailModalLayout = ({ closeModal, undoEmailSending, isOpen, countdownTime }: SendEmailModalLayoutProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onToggle={closeModal}
      title="Email is sent"
      hasCancelButton={false}
      buttons={
        countdownTime > 0 ? (
          <Button color="primary" variant="outlined" onClick={undoEmailSending}>
            Undo
          </Button>
        ) : (
          []
        )
      }
    >
      <p>This e-mail has been sent successfully!</p>
      {countdownTime > 0 && <p>{`In case you need it you have ${countdownTime} seconds to undo sending.`}</p>}
    </Modal>
  );
};

export default SendEmailModalLayout;
